import React from 'react'

export default () => (
  <svg viewBox="0 0 14 10">
    <path fillRule="evenodd" clipRule="evenodd" d="m9.474.074-.48.493 3.635 3.8H0v.703h12.629l-3.635 3.8.48.493L14 4.718 9.474.074Z"/>
  </svg>
)
